import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row, Form, FormFeedback, Label, Input, Offcanvas, OffcanvasHeader, OffcanvasBody, Button, Card, CardBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Spinner, ButtonGroup, CardHeader, UncontrolledCollapse, Nav, NavItem, NavLink, TabContent, TabPane, Badge } from 'reactstrap';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { justNums, handleFormError, showToast, getCountries, getDDLOptions, } from '../../helpers/common_helper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import FeatherIcon from 'feather-icons-react';
import { CSVLink } from 'react-csv';
import { axiosPOST, CSVHeader, PDFExport, tableFetch, CSVExport, dtColumnConfig, axiosGET, } from '../../helpers/datatable_helper';
import Swal from 'sweetalert2';
import moment from 'moment';
import { translate } from '../../helpers/language_helper';
import { FilePond, registerPlugin } from 'react-filepond';
import { Link } from 'react-router-dom';
import Nouislider from 'nouislider-react';
import Flatpickr from "react-flatpickr";

const Visitors = () => {
    document.title = 'Visitors Report | Kinderiffic';
    const offCanvasWidth = '35%';

    // States-E-Module
    const { USER, CENTER, layoutModeType } = useSelector((state) => ({
        USER: state.User,
        CENTER: state.Center,
        layoutModeType: state.Layout.layoutModeType
    }));
    const basePathChild = `${process.env.REACT_APP_API_URL}/web/attachments/centers/${CENTER.center_id}/children/`;

    const [state, setState] = useState({
        form_processing: false,
        loading: false,
        validationErrors: '',
    });

    const [Filter, setFilter] = useState({
        daterange: moment().format('DD-MM-YYYY'),
    });

    const [stateDT, setStateDT] = useState({
        // START DT START
        // THIS MUST BE DEFINED IF DATATABLES ARE BEING USED FOR SHOW/HIDE COLS
        dtCols: {},
        dtSort: {
            field: 'invda_id',
            dir: 'DESC',
        },
        dtData: [],
        dtExportCSV: [],
        dtTotalRows: 0,
        dtPerPage: 10,
        dtCurrentPage: 1,
        dtSearchKeyword: '',
        statusAll: false,
        loading: false,
        // START DT END
    });


    // Datatable: columns
    // BASED ON THESE STATES IT WILL FETCH THE DATA AGAIN
    useEffect(() => {
        fetchData(stateDT.dtCurrentPage);
    }, [stateDT.dtSort, stateDT.dtSearchKeyword, Filter.daterange]);
    const dtColumns = [
        {
            ...dtColumnConfig('child_name', stateDT),
            name: translate('Child'),
            selector: (row) => (
                <div className='text-center my-1'>
                    {row.picture &&
                        <img
                            className='rounded-top avatar-md'
                            src={basePathChild + row.picture}
                            alt={row.picture}
                        />
                    }
                    <div>{row.child_name}</div>
                </div>
            )
        },
        {
            ...dtColumnConfig('parent_name', stateDT),
            name: translate('Parent')
        },
        {
            ...dtColumnConfig('invda_activation_datetime', stateDT),
            name: translate('Activation Time'),
            width: '200px',
            selector: (row) => (
                <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
                    <div><Badge color="primary">{moment(row.invda_activation_date).format('DD-MM-YYYY')}</Badge></div>
                    <Badge color="warning">{moment(row.invda_activation_datetime).format('HH:mm:ss')}</Badge>
                </div>

            )
        },
        {
            ...dtColumnConfig('created_on', stateDT),
            name: translate('Member since'),
            width: '200px',
            selector: (row) => (
                <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
                    <div><Badge color="primary">{moment(row.created_on, "YYYY-MM-DD HH:mm:ss").fromNow(true)}</Badge></div>
                </div>

            )
        },
    ];
    // Datatable: header component
    const subHeaderComponent = (
        <>
            {/* CSV,PDF DOWNLOAD BTNS */}
            <ButtonGroup className='btn btn-sm' size='sm'>
                <CSVLink
                    headers={CSVHeader(dtColumns)}
                    filename={'csv_' + moment().unix() + '.csv'}
                    data={stateDT.dtExportCSV}
                    asyncOnClick={true}
                    onClick={(event, done) =>
                        CSVExport(
                            dtColumns,
                            stateDT.dtData,
                            stateDT,
                            setStateDT,
                            done
                        )
                    }
                    className='btn btn-primary btn-sm'>
                    {translate('CSV')}
                </CSVLink>
                <Button
                    className='btn btn-primary btn-sm'
                    onClick={() => PDFExport(dtColumns, stateDT.dtData)}>
                    {translate('PDF')}
                </Button>
            </ButtonGroup>

            <UncontrolledDropdown className='me-3'>
                <DropdownToggle
                    tag='button'
                    className='btn btn-light btn-sm'
                    id='dropdownMenuButton'>
                    {translate('Columns Visibility')}{' '}
                    <i className='mdi mdi-chevron-down'></i>
                </DropdownToggle>
                <DropdownMenu>
                    {dtColumns.map(
                        (item, index) =>
                            item.key != null && (
                                <DropdownItem
                                    key={index}
                                    onClick={() =>
                                        setStateDT({
                                            ...stateDT,
                                            dtCols: {
                                                ...stateDT.dtCols,
                                                [item.key]:
                                                    !stateDT.dtCols[item.key],
                                            },
                                        })
                                    }
                                    className={item.omit ? 'text-muted' : ''}>
                                    <FeatherIcon
                                        className='me-1'
                                        icon={item.omit ? 'eye-off' : 'eye'}
                                        size={14}
                                    />{' '}
                                    {item.name}
                                </DropdownItem>
                            )
                    )}
                </DropdownMenu>
            </UncontrolledDropdown>
            <div className='form-icon right'>
                <Input
                    value={stateDT.dtSearchKeyword}
                    type='text'
                    className='form-control form-control-sm form-control-icon'
                    id='iconleftInput'
                    placeholder={translate('Search here...')}
                    onChange={(e) =>
                        setStateDT({
                            ...stateDT,
                            dtSearchKeyword: e.target.value,
                        })
                    }
                />
                {stateDT.dtSearchKeyword != '' ? (
                    <i
                        onClick={() =>
                            setStateDT({ ...stateDT, dtSearchKeyword: '' })
                        }
                        className='mdi mdi-close-thick search-widget-icon'
                        style={{ fontSize: '15px' }}></i>
                ) : (
                    <i
                        className='mdi mdi-magnify search-widget-icon'
                        style={{ fontSize: '15px' }}></i>
                )}
            </div>
        </>
    );
    // Datatable: fetch data
    let fetchDataReq;
    const fetchData = async (page, newPerPage = stateDT.dtPerPage) => {
        setStateDT({ ...stateDT, loading: true });
        if (fetchDataReq) {
            fetchDataReq.abort();
        }
        fetchDataReq = new AbortController();
        let parameters = {
            center_id: USER.center_id,
            offset: (page - 1) * newPerPage,
            order: stateDT.dtSort.field,
            dir: stateDT.dtSort.dir,
            page: page,
            limit: newPerPage,
            search: stateDT.dtSearchKeyword,
            only_active: stateDT.statusAll,
            filter: Filter
        };

        const res = await tableFetch(
            'report-visitors/fetch',
            fetchDataReq,
            parameters
        );
        if (res) {
            console.log('tableFetchres', res);
            setStateDT({
                ...stateDT,
                dtData: res.data,
                dtTotalRows: res.total_count_filtered,
                loading: false,
                dtCurrentPage: page,
                dtPerPage: newPerPage,
            });
        } else {
            setStateDT({ ...stateDT, loading: false });
        }
    };




    const filterDateRange = (days) => {
        setFilter({ ...Filter, daterange: moment().subtract(days, 'day').format('DD-MM-YYYY') + ' to ' + moment().format('DD-MM-YYYY') })
    }

    //START FOR CALLBACK STATES
    const myCallbacksList = useRef([]);
    const setStateWCall = (newState, callback) => {
        setState(newState);
        if (callback) myCallbacksList.current.push(callback);
    };
    useEffect(() => {
        myCallbacksList.current.forEach((callback) => callback(state));
        myCallbacksList.current = [];
    }, [state]);
    //END FOR CALLBACK STATES

    useEffect(() => {
        async function componentDidMount() {
        }
        componentDidMount()
    }, []);


    return (
        <React.Fragment>
            <ToastContainer />
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div
                                className='page-title-box d-sm-flex align-items-center justify-content-between'
                                style={{ minHeight: '58px' }}>
                                <h4 className='mb-sm-0'>{translate('Visitors Report')}</h4>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={3} lg={4}>
                            <Card>
                                <CardHeader >
                                    <div className="d-flex mb-3">
                                        <div className="flex-grow-1">
                                            <h5 className="fs-16">Filters</h5>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <Link to="#" className="text-decoration-underline" onClick={() => setFilter({ ...Filter, daterange: moment().format('DD-MM-YYYY') })}>
                                                Clear All
                                            </Link>
                                        </div>
                                    </div>

                                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                                        Date Range
                                    </p>
                                    <Flatpickr
                                        value={Filter.daterange}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd-m-Y',
                                            mode: 'range'
                                        }}
                                        onChange={(date) => {
                                            if (date.length == 2) {
                                                setFilter({ ...Filter, daterange: moment(date[0]).format('DD-MM-YYYY') + ' to ' + moment(date[1]).format('DD-MM-YYYY') })
                                            }
                                        }}
                                    />

                                </CardHeader>
                                <CardBody>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(0)}>
                                        Today
                                    </span>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(1)}>
                                        Yesterday
                                    </span>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(3)}>
                                        Last 3 Days
                                    </span>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(7)}>
                                        Last 7 Days
                                    </span>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(15)}>
                                        Last 15 Days
                                    </span>
                                    <span className="badge bg-success rounded-pill align-middle me-1 mb-2 cursor-pointer" style={{ fontSize: '14px' }}
                                        onClick={() => filterDateRange(30)}>
                                        Last 30 Days
                                    </span>
                                </CardBody>
                            </Card>
                        </Col>

                        <div className="col-xl-9 col-lg-8">
                            <div>
                                <div className="card">
                                    {/* <div className="card-header border-0">
                                        <div className="row g-4">
                                            <div className="col-sm-auto">

                                            </div>
                                            <div className="col-sm">
                                                <div className="d-flex justify-content-sm-end">

                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="card-body">
                                        <DataTable
                                            columns={dtColumns}
                                            data={stateDT.dtData}
                                            progressPending={stateDT.loading}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={stateDT.dtTotalRows}
                                            onChangePage={(page) => fetchData(page)}
                                            onChangeRowsPerPage={(newPerPage, page) =>
                                                fetchData(page, newPerPage)
                                            }
                                            paginationComponentOptions={{
                                                selectAllRowsItem: true,
                                            }}
                                            subHeader
                                            subHeaderComponent={subHeaderComponent}
                                            onSort={(column, sortDirection) =>
                                                setStateDT({
                                                    ...stateDT,
                                                    dtSort: {
                                                        field: column.key,
                                                        dir: sortDirection.toUpperCase(),
                                                    },
                                                })
                                            }
                                            sortServer
                                            theme={
                                                layoutModeType == 'dark'
                                                    ? 'dark'
                                                    : 'default'
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>

                </Container>

            </div>
        </React.Fragment>
    );
};

export default Visitors;
